const JSON_RESERVED: Record<'{' | '}' | '[' | ']' | ':' | ',' | '"' | "'" | '\\' | '`', string> = {
  '{': '__LEFT_BRACE__',
  '}': '__RIGHT_BRACE__',
  '[': '__LEFT_BRACKET__',
  ']': '__RIGHT_BRACKET__',
  ':': '__COLON__',
  ',': '__COMMA__',
  '"': '__DOUBLE_QUOTE__',
  "'": '__SINGLE_QUOTE__',
  '\\': '__BACKSLASH__',
  '`': '__BACKTICK__',
};

export function neutralizeScriptTag(message: string) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(message, 'text/html');

  const scriptTags = Array.from(doc.querySelectorAll('script'));
  for (const script of scriptTags) {
    const replacement = document.createTextNode('[XSS attempted msg inj by chat]' + script.textContent);
    script.replaceWith(replacement);
  }

  return doc.body.innerHTML;
}

export function sanitizeHtml(dirtyHtml: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(dirtyHtml, 'text/html');

  // Remove dangerous elements
  const dangerousTags = ['script', 'iframe', 'object', 'embed', 'applet', 'link', 'meta', 'style'];
  dangerousTags.forEach(tag => {
    doc.querySelectorAll(tag).forEach(el => el.remove());
  });

  doc.body.childNodes.forEach(node => {
    if (node.nodeType === 1) {
      walk(node as Element);
    }
  });

  return doc.body.innerHTML;
}

// Clean attributes
const walk = (el: Element) => {
  // Copy attribute names first (since we'll modify attributes while looping)
  Array.from(el.attributes).forEach(attr => {
    const name = attr.name.toLowerCase();
    const value = attr.value;

    // Remove event handlers (on*)
    if (name.startsWith('on')) {
      el.removeAttribute(name);
      return;
    }

    // Remove javascript: or data: URIs
    if (['src', 'href', 'xlink:href'].includes(name)) {
      if (/^\s*javascript:/i.test(value) || /^\s*data:/i.test(value)) {
        el.removeAttribute(name);
      }
    }

    // Inline styles may contain expression() or url(javascript:...)
    if (name === 'style') {
      if (/expression|url\s*\(\s*javascript:/i.test(value)) {
        el.removeAttribute(name);
      }
    }
  });

  // Recursively sanitize children
  el.childNodes.forEach(node => {
    if (node.nodeType === 1) {
      walk(node as Element);
    }
  });
};

export const escapeJSONReservedChars = (str: string): string => {
  return str.replace(/[{}[\]:,"'\\`]/g, (match: string) => JSON_RESERVED[match as keyof typeof JSON_RESERVED]);
};

export const restoreProblematicChars = (str: string) => {
  let restored = str;
  for (const [char, placeholder] of Object.entries(JSON_RESERVED)) {
    const regex = new RegExp(placeholder, 'g');
    restored = restored.replace(regex, char);
  }
  return restored;
};
